import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { Home } from "../views";

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        <Route path={"/"} element={<Home />} exact />
      </Routes>
    </Router>
  );
};

export default AppRouter;
